import React, {
  useState,
  useEffect,
  useImperativeHandle,
  forwardRef,
} from "react";
import AInput from "../../../../common/formFeilds/customInput/AInput";
import moment from "moment";
import ADataGrid from "../../../../common/data-grid/ADataGrid";
import { GridRowModes } from "@mui/x-data-grid";

import { isActiveBusinessArea } from "views/pages/manage/unAssigned/collectPayment/utils.jsx";
import {
  fetchAllPromisedData,
  isObjEmpty,
} from "../../../../common/utils/methods/commonMethods/utilityMethod";
import {
  failureToast,
  successToast,
} from "../../../../common/utils/methods/toasterFunctions/function";
import { saveOrDeleteMsg } from "../../../../edpOps/stockManagement/mastersAndMapping/sapProfitCostCentreMapping/constant";
import { generateRandomId } from "../../../../common/utils/methods/commonMethods/utilityMethod";
import { AGridColDef } from "../../../../common/data-grid/ADataGridColDef";
import { editCellContainerStyle } from "../../../../edpOps/stockManagement/mastersAndMapping/onBoardingMaterialIdSetup/constant";
import AAutoComplete from "../../../../common/form-fields-mui/AAutoComplete";
import {
  gridStyles,
  gridComponents,
} from "../../../../edpOps/issuanceIDcard/printIdCardAndMapRfid/constant";
import {
  ActionsCellComponent,
  StatusCellComponent,
} from "../../paymentGatewaysConfiguration/common";
import { machineTypes, newRow, vendorTypes } from "./common";
import ALoader from "../../../../common/a-loader";
import NoRowOverlay from "../../../holidayMaster/NoRowOverlay";
import { FaCheckSquare } from "react-icons/fa";
import { endpoint } from "../../../../common/constant";
import { ReactComponent as CloseIcon } from "../../../../../../../assets/img/svg/CloseSquareBlack.svg";

const ListComponent = (
  {
    businessAreaDropdown = [],
    rows = [],
    createUpdateHandler,
    loading,
    currentPage,
    totalRecords,
    pageChangeHandler,
    setLoading,
    isUpdatePermission,
  },
  ref
) => {
  const [rowModesModel, setRowModesModel] = useState({});
  const [rowData, setRowData] = useState(rows);
  const [rowForm, setRowForm] = useState({});

  const validateUserId = async () => {
    if (!rowForm?.userId) return;
    try {
      setLoading(true);
      const resp = await fetchAllPromisedData(
        `${endpoint.getAllUserByUserKeyList}?userKeyList=${rowForm?.userId}`,
        true,
        false
      );
      if (resp?.code === 200 && resp?.data?.length > 0) {
        setRowForm((prev) => ({
          ...prev,
          userName: resp?.data[0]?.name,
        }));
        successToast("User ID validated successfully!!");
      } else {
        failureToast("Please enter a valid user ID");
      }
      setLoading(false);
    } catch (err) {
      console.error(err);
      setLoading(false);
    }
  };

  // const onKeyDownHandler = (e) => {
  //     if (e.key === 'Enter' || e.keyCode === 13) {
  //       validateUserId();
  //     }
  //   }

  const rowFormHandler = (value, key) =>
    setRowForm((prev) => ({
      ...prev,
      [key]: value,
      ...(key === "userId" && { userName: "" }),
    }));

  useEffect(() => {
    setRowData(rows);
  }, [rows]);

  const startEditing = (id, form) => {
    setRowModesModel((oldModel) => ({
      [id]: { mode: GridRowModes.Edit, fieldToFocus: "financeInstitution" },
    }));
    setRowForm(form);
  };

  const stopEditing = () => {
    const currForm = { ...rowForm };
    setRowModesModel((oldModel) => ({
      [currForm?.id]: { mode: GridRowModes.View, ignoreModifications: true },
    }));
    setRowForm({});
  };

  const handleEditClick = (params) => {
    if (!isObjEmpty(rowForm)) {
      failureToast(saveOrDeleteMsg);
    } else {
      startEditing(params?.id, params?.row);
    }
  };

  const handleCancelClick = async (params) => {
    if (params?.row?.isNew) {
      setRowData(rows);
      setRowForm({});
    } else {
      stopEditing(params?.id);
    }
  };

  const handleSaveClick = async (params) => {
    createUpdateHandler(rowForm);
  };

  const addNewRow = async () => {
    if (!isObjEmpty(rowForm)) {
      failureToast(saveOrDeleteMsg);
    } else {
      let randomId = generateRandomId();
      let emptyRow = {
        ...newRow,
        isNew: true,
        id: randomId,
      };
      startEditing(randomId, emptyRow);
      setRowData((prev) => [emptyRow, ...prev]);
    }
  };

  useImperativeHandle(ref, () => ({
    addNewRow: addNewRow,
    startEditing: startEditing,
    stopEditing: stopEditing,
  }));

  const columns = [
    new AGridColDef("businessArea", "Business Area")
      .setMinWidth(110)
      .setFlex(0.5)
      .editable(true)
      .setValueGetter((params) => params?.value?.label)
      .renderEditCellComponent((params) => (
        <div style={editCellContainerStyle}>
          <AAutoComplete
            currentValue={rowForm?.businessArea}
            handleChange={(value) => {
              rowFormHandler(value, "businessArea");
            }}
            items={businessAreaDropdown}
            isMulti={false}
            //   style={selectStyles}
            placeholder={"Select"}
            autoFocus={params?.hasFocus}
            isDisabled={!rowForm?.isNew}
          />
        </div>
      )),
    new AGridColDef("description", "Description")
      .setMinWidth(110)
      .setFlex(0.8)
      .editable(true)
      .setValueGetter((params) => params?.row?.businessArea?.businessAreaDesc)
      .renderEditCellComponent((params) => (
        <div style={editCellContainerStyle}>
          <AInput
            value={rowForm?.businessArea?.businessAreaDesc}
            // handler={val => rowFormHandler(val, 'merchantId')}
            placeholder={"Enter"}
            maxLength={100}
            disabled
          />
        </div>
      )),
    new AGridColDef("userId", "User ID")
      .setMinWidth(110)
      .setFlex(0.8)
      .editable(true)
      .setValueGetter((params) => params?.value)
      .renderEditCellComponent((params) => (
        <div style={editCellContainerStyle}>
          <AInput
            value={rowForm?.userId}
            handler={(val) => rowFormHandler(val, "userId")}
            placeholder={"Enter"}
            maxLength={100}
            rightCustomIcon={
              <FaCheckSquare
                style={{
                  color: rowForm?.userId ? "#00B0F5" : "#D3D3D3",
                  backgroundColor: "#FFF",
                  fontSize: "20px",
                  top: "3px",
                  right: "5px",
                  position: "absolute",
                  bottom: "0",
                  margin: "auto 0",
                  cursor: rowForm?.userId ? "pointer" : "not-allowed",
                }}
                onClick={validateUserId}
              />
            }
            // onKeyDown={onKeyDownHandler}
          />
        </div>
      )),
    new AGridColDef("userName", "User Name", false)
      .setMinWidth(110)
      .setFlex(0.8)
      .editable(true)
      .setValueGetter((params) => params?.value)
      .renderEditCellComponent((params) => (
        <div style={editCellContainerStyle}>
          <AInput
            value={rowForm?.userName}
            // handler={val => rowFormHandler(val, 'userName')}
            placeholder={"Enter"}
            maxLength={100}
            disabled
          />
        </div>
      )),
    new AGridColDef("vendorType", "Vendor Type")
      .setMinWidth(110)
      .setFlex(1)
      .editable(true)
      .setValueGetter((params) => params?.value?.label)
      .renderEditCellComponent((params) => (
        <div style={editCellContainerStyle}>
          <AAutoComplete
            currentValue={rowForm?.vendorType}
            handleChange={(value) => {
              rowFormHandler(value, "vendorType");
            }}
            items={vendorTypes}
            isMulti={false}
            placeholder={"Select"}
            autoFocus={params?.hasFocus}
            // isDisabled={!rowForm?.isNew}
          />
        </div>
      )),
    new AGridColDef("posId", "POS ID", false)
      .setMinWidth(110)
      .setFlex(0.8)
      .editable(true)
      .setValueGetter((params) => params?.value)
      .renderEditCellComponent((params) => (
        <div style={editCellContainerStyle}>
          <AInput
            value={rowForm?.posId}
            handler={(val) => rowFormHandler(val, "posId")}
            placeholder={"Enter"}
            maxLength={100}
          />
        </div>
      )),
    new AGridColDef("imei", "IMEI", false)
      .setMinWidth(110)
      .setFlex(0.5)
      .editable(true)
      .setValueGetter((params) => params?.value)
      .renderEditCellComponent((params) => (
        <div style={editCellContainerStyle}>
          <AInput
            value={rowForm?.imei}
            handler={(val) => rowFormHandler(val, "imei")}
            placeholder={"Enter"}
            maxLength={100}
          />
        </div>
      )),

    new AGridColDef("type", "Machine Type", false)
      .setMinWidth(110)
      .setFlex(0.5)
      .editable(true)
      .setValueGetter((params) => params?.value?.label)
      .renderEditCellComponent((params) => (
        <div style={editCellContainerStyle}>
          <AAutoComplete
            currentValue={rowForm?.type}
            handleChange={(value) => {
              rowFormHandler(value, "type");
            }}
            items={machineTypes}
            isMulti={false}
            //   style={selectStyles}
            placeholder={"Select"}
            autoFocus={params?.hasFocus}
            isDisabled={!rowForm?.isNew}
          />
        </div>
      )),

    new AGridColDef("updatedOn", "Last Updated")
      .setMinWidth(110)
      .setFlex(0.8)
      .editable(false)
      .setValueGetter(
        (params) =>
          `${moment(params.value).format("DD-MMM-YY")} by ${
            params.row.updatedBy
          }`
      ),

    new AGridColDef("status", "Status", false)
      .setMinWidth(90)
      .setFlex(0.5)
      .editable(true)
      .renderCellComponent((params) => (
        <StatusCellComponent value={params.value} />
      ))
      .renderEditCellComponent((params) => (
        <StatusCellComponent
          value={rowForm?.status}
          handleChange={(val) => rowFormHandler(val, "status")}
        />
      )),

    new AGridColDef("actions", "Action", false)
      .setMinWidth(110)
      .setFlex(0.8)
      .editable(true)
      // .pinColumnLast(true)
      .columnAlign("right")
      .renderCellComponent(
        (params) =>
          isUpdatePermission &&
          isActiveBusinessArea({ buLabel: params.row.businessAreaValue }) && (
            <ActionsCellComponent
              mode={"view"}
              handleEditClick={handleEditClick}
              params={params}
            />
          )
      )
      .renderEditCellComponent((params) => (
        <ActionsCellComponent
          mode={"edit"}
          isSaveDisabled={!rowForm?.userName}
          handleSaveClick={handleSaveClick}
          // handleCancelClick={handleCancelClick}
          params={params}
          cancelIcon={
            <CloseIcon
              className="mx-2 cursor"
              onClick={() => handleCancelClick(params)}
            />
          }
        />
      )),
  ];

  return (
    <>
      {loading && <ALoader position="fixed" />}
      <ADataGrid
        removeWrapperContainer
        rowModesModel={rowModesModel}
        rows={rowData || []}
        columns={columns}
        rowId={(row) => row.id}
        rowHeight={50}
        loading={false}
        rowCount={totalRecords}
        nextButtonHandler={pageChangeHandler}
        currentPage={currentPage}
        components={{
          ...gridComponents,
          NoRowsOverlay: () => (
            <NoRowOverlay message={loading ? "Loading..." : null} />
          ),
        }}
        sx={gridStyles}
        autoHeight
        // pinLastColumn
      />
    </>
  );
};

export default forwardRef(ListComponent);
